export default __webpack_public_path__ + "static/media/Celling Type Presence Detector.f0d96a4f.pdf";